import React, { useContext } from 'react';
import { Image, NavBar } from 'antd-mobile';
import LayoutContext, { IFlexUserLayoutContext } from '@/context/FlexUserLayoutContext';
import styles from './styles.module.pcss';
import { currentUserInitialState, currentUserVar, setCurrentUser } from '@/graphql/operations/user';
import { Link, useNavigate } from 'react-router-dom';
import LocalStorageService from '@/service/LocalStorage';
import { useApolloClient, useReactiveVar } from '@apollo/client';
import { LogOut } from 'react-feather';
import classNames from 'classnames';

const MobileHeader = () => {
  const currentUser = useReactiveVar(currentUserVar);
  const navigate = useNavigate();
  const layoutContext = useContext<IFlexUserLayoutContext>(LayoutContext);
  const client = useApolloClient();

  const onLogout = async () => {
    await client.clearStore();
    setCurrentUser(currentUserInitialState);
    LocalStorageService.clear();
    navigate('/signin', { replace: true });
  };

  const logoutButton = (
    <div style={{ fontSize: 24, marginRight: '8px', justifyItems: 'flex-end' }}>
      <LogOut onClick={onLogout} />
    </div>
  );

  return (
    <NavBar
      className={classNames(styles.navbar, {
        [styles.mobile]: layoutContext.isMobile,
      })}
      right={currentUser.isAuthenticated ? logoutButton : null}
      backIcon={null}
    >
      <Link to="/">
        <div className={styles.logo}>
          <Image
            src={
              layoutContext.layoutConfig.darkLogo
                ? layoutContext.layoutConfig.darkLogo
                : layoutContext.layoutConfig.logo
            }
            alt="logo"
            fit="contain"
          />
        </div>
      </Link>
    </NavBar>
  );
};

export default MobileHeader;
